import TooltipWrapper from "../../../../ui/TooltipWrapper/TooltipWrapper";
import LinkedinTargetAudience from "./LinkedinTargetAudience";
import {
  LINKEDIN_TARGET_AUDIENCE_LISTS,
  type LinkedInTargeting,
} from "./use-linkedin-targeting";

/*
 * The rendered half of the shared rule. Both the single platform form and the
 * cluster form render this, so the three visibility states read the same in
 * either place: hidden with no LinkedIn account, disabled with a reason on more
 * than one account or on a personal profile, and live on a single company page.
 */
export function LinkedinTargetAudienceField({
  targeting,
  disabled,
}: {
  targeting: LinkedInTargeting;
  disabled?: boolean;
}) {
  if (!targeting.isVisible) {
    return null;
  }

  const isDisabled = Boolean(disabled) || targeting.isDisabled;

  const trigger = (
    <div className="flex max-w-[500px] justify-between">
      <div data-testid="targetAudiences">
        {targeting.audienceLabels.length > 0
          ? targeting.audienceLabels.map((label) => (
              <div key={label}>{label}</div>
            ))
          : "Anyone"}
      </div>
      {/*
        `pointer-events-none` on the disabled button is what lets the tooltip
        fire: a disabled button swallows hover, so without it the reason never
        reaches the user who most needs it.
      */}
      <button
        type="button"
        data-testid="target-audience-trigger"
        disabled={isDisabled}
        onClick={targeting.openModal}
        className={`whitespace-nowrap pl-5 underline ${
          isDisabled
            ? "pointer-events-none cursor-not-allowed text-neutral-400"
            : "cursor-pointer text-[#4f31ff]"
        }`}
      >
        Target Audience
      </button>
    </div>
  );

  return (
    <>
      {/* mt-[30px] preserves the spacing the old PostVisibilityStyled carried. */}
      <p className="mt-[30px] text-[15px] font-bold">Post visibility</p>

      {targeting.disabledTooltip ? (
        <TooltipWrapper tooltip={targeting.disabledTooltip}>
          {trigger}
        </TooltipWrapper>
      ) : (
        trigger
      )}

      {targeting.isModalOpen && (
        <LinkedinTargetAudience
          showModal={targeting.isModalOpen}
          onCloseModal={targeting.closeModal}
          lists={LINKEDIN_TARGET_AUDIENCE_LISTS}
          selectedItems={targeting.audience}
        />
      )}
    </>
  );
}

export default LinkedinTargetAudienceField;
